const DEBOUNCE_TIME = 10;
const IOS_DELAY = 500;

export { DEBOUNCE_TIME, IOS_DELAY };
